var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path, _path2, _path3, _path4, _path5, _rect2, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeofpingus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 784,
    height: 564,
    viewBox: "0 0 784 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 131.034,
    width: 784,
    height: 340.634,
    fill: "#E1B166"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.331,
    cy: 301.352,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 31.9006 293.782)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3311,
    cy: 301.352,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.262,
    cy: 306.759,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 761.831 299.189)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1793,
    cy: 263.503,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 69.7484 255.934)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1791,
    cy: 263.504,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1793,
    cy: 339.2,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 69.7484 331.63)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1791,
    cy: 339.2,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.364,
    cy: 67.5,
    r: 24.5455,
    fill: "white",
    stroke: "#3E3A39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.773 72.1023C404.773 75.6818 399.25 87.1364 389.432 85.9091",
    stroke: "#3E3A39",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 80.4462C336.588 80.4462 336.676 39.1521 337.117 18.5051C337.158 16.3965 331.849 54.5276 329.189 73.8567C324.961 91.78 336.236 136.676 342.402 156.884V200.374C342.402 215.135 337.998 210.039 335.795 205.646C333.681 207.755 331.391 185.438 330.51 174.017C330.51 175.071 328.748 181.485 327.867 184.56C318.618 239.911 334.474 245.183 337.117 245.183C339.759 245.183 339.759 286.038 337.117 284.72C334.474 283.402 331.831 272.859 327.867 272.859C324.696 272.859 326.546 303.609 327.867 318.985C327.867 322.148 334.034 325.574 337.117 326.892C336.676 332.603 336.06 346.397 337.117 355.886C338.438 367.747 331.831 367.747 331.831 370.383C331.831 372.491 336.236 372.14 338.438 371.701C338.878 372.14 339.759 374.073 339.759 378.29C339.759 383.562 334.474 386.197 333.153 390.151C332.096 393.314 334.474 402.012 335.795 405.966C335.795 407.284 335.003 409.92 331.831 409.92C327.867 409.92 331.831 420.463 333.153 431.006C334.21 439.44 330.951 450.335 329.189 454.728C324.96 454.728 328.308 464.392 330.51 469.225L325.225 561.477H460L457.357 524.576L453.393 469.225C456.036 465.271 460.529 457.364 457.357 457.364C454.186 457.364 449.87 447.699 448.108 442.867V413.873C437.537 401.221 436.657 398.059 437.537 398.059H448.108C451.279 398.059 444.144 390.151 440.18 386.197C437.097 382.244 431.195 373.809 432.252 371.701C433.573 369.065 436.216 373.019 440.18 375.654C443.351 377.763 444.144 372.14 444.144 369.065C443.704 366.429 442.03 359.049 438.859 350.614C435.688 342.18 438.418 330.407 440.18 325.574L448.108 316.349C448.108 311.956 447.844 302.116 446.787 297.899C445.73 293.681 447.227 273.298 448.108 263.633L446.787 265.61L445.465 267.587L440.18 287.355C431.724 300.007 429.61 283.841 429.61 274.176C429.61 255.199 436.657 251.333 440.18 251.772C450.751 254.935 451.632 209.16 450.751 185.878C446.522 164.791 445.465 169.184 445.465 174.017C445.025 184.56 443.351 206.437 440.18 209.6C437.009 212.763 434.454 214.432 433.573 214.871V151.612C439.916 149.504 445.906 115.59 448.108 98.8967C456.036 90.9893 437.537 -2.58115 437.537 0.0546368C437.537 2.16327 434.895 50.1346 433.573 73.8567C432.516 90.7257 422.562 107.243 417.718 113.393C400.805 123.937 373.673 121.301 362.222 118.665C348.48 114.448 341.521 91.4286 339.759 80.4462Z",
    fill: "#3E3A39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M371.023 563.011H340.341C340.852 531.818 344.943 472.5 355.682 472.5C360.284 472.5 371.023 485.693 371.023 563.011Z",
    fill: "#302C2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444.659 563.011H413.977C414.489 531.818 418.58 472.5 429.318 472.5C433.92 472.5 444.659 485.693 444.659 563.011Z",
    fill: "#302C2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M407.841 563.011H377.159C377.67 531.818 381.761 472.5 392.5 472.5C397.102 472.5 407.841 485.693 407.841 563.011Z",
    fill: "#302C2B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 131.034,
    width: 784,
    height: 340.634,
    fill: "#E1B166"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.331,
    cy: 301.352,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 31.9006 293.782)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3311,
    cy: 301.352,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 754.262,
    cy: 306.759,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 761.831 299.189)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeOpacity: 0.3,
    strokeWidth: 0.2
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1793,
    cy: 263.503,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 69.7484 255.934)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1791,
    cy: 263.504,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1793,
    cy: 339.2,
    r: 18.9241,
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.56966,
    cy: 7.56966,
    r: 7.56966,
    transform: "matrix(-1 0 0 1 69.7484 331.63)",
    fill: "#D9D9D9",
    stroke: "#776C6C",
    strokeWidth: 0.2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1791,
    cy: 339.2,
    r: 15.1393,
    fill: "#EDCC8B",
    fillOpacity: 0.79
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.364,
    cy: 67.5,
    r: 24.5455,
    fill: "white",
    stroke: "#3E3A39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404.773 72.1023C404.773 75.6818 399.25 87.1364 389.432 85.9091",
    stroke: "#3E3A39",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M339.759 80.4462C336.588 80.4462 336.676 39.1521 337.117 18.5051C337.158 16.3965 331.849 54.5276 329.189 73.8567C324.961 91.78 336.236 136.676 342.402 156.884V200.374C342.402 215.135 337.998 210.039 335.795 205.646C333.681 207.755 331.391 185.438 330.51 174.017C330.51 175.071 328.748 181.485 327.867 184.56C318.618 239.911 334.474 245.183 337.117 245.183C339.759 245.183 339.759 286.038 337.117 284.72C334.474 283.402 331.831 272.859 327.867 272.859C324.696 272.859 326.546 303.609 327.867 318.985C327.867 322.148 334.034 325.574 337.117 326.892C336.676 332.603 336.06 346.397 337.117 355.886C338.438 367.747 331.831 367.747 331.831 370.383C331.831 372.491 336.236 372.14 338.438 371.701C338.878 372.14 339.759 374.073 339.759 378.29C339.759 383.562 334.474 386.197 333.153 390.151C332.096 393.314 334.474 402.012 335.795 405.966C335.795 407.284 335.003 409.92 331.831 409.92C327.867 409.92 331.831 420.463 333.153 431.006C334.21 439.44 330.951 450.335 329.189 454.728C324.96 454.728 328.308 464.392 330.51 469.225L325.225 561.477H460L457.357 524.576L453.393 469.225C456.036 465.271 460.529 457.364 457.357 457.364C454.186 457.364 449.87 447.699 448.108 442.867V413.873C437.537 401.221 436.657 398.059 437.537 398.059H448.108C451.279 398.059 444.144 390.151 440.18 386.197C437.097 382.244 431.195 373.809 432.252 371.701C433.573 369.065 436.216 373.019 440.18 375.654C443.351 377.763 444.144 372.14 444.144 369.065C443.704 366.429 442.03 359.049 438.859 350.614C435.688 342.18 438.418 330.407 440.18 325.574L448.108 316.349C448.108 311.956 447.844 302.116 446.787 297.899C445.73 293.681 447.227 273.298 448.108 263.633L446.787 265.61L445.465 267.587L440.18 287.355C431.724 300.007 429.61 283.841 429.61 274.176C429.61 255.199 436.657 251.333 440.18 251.772C450.751 254.935 451.632 209.16 450.751 185.878C446.522 164.791 445.465 169.184 445.465 174.017C445.025 184.56 443.351 206.437 440.18 209.6C437.009 212.763 434.454 214.432 433.573 214.871V151.612C439.916 149.504 445.906 115.59 448.108 98.8967C456.036 90.9893 437.537 -2.58115 437.537 0.0546368C437.537 2.16327 434.895 50.1346 433.573 73.8567C432.516 90.7257 422.562 107.243 417.718 113.393C400.805 123.937 373.673 121.301 362.222 118.665C348.48 114.448 341.521 91.4286 339.759 80.4462Z",
    fill: "#3E3A39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M371.023 563.011H340.341C340.852 531.818 344.943 472.5 355.682 472.5C360.284 472.5 371.023 485.693 371.023 563.011Z",
    fill: "#302C2B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M444.659 563.011H413.977C414.489 531.818 418.58 472.5 429.318 472.5C433.92 472.5 444.659 485.693 444.659 563.011Z",
    fill: "#302C2B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M407.841 563.011H377.159C377.67 531.818 381.761 472.5 392.5 472.5C397.102 472.5 407.841 485.693 407.841 563.011Z",
    fill: "#302C2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeofpingus);
export default __webpack_public_path__ + "static/media/Eyeofpingus.3c374ae1ec88dccfc41bc0ef4e62646b.svg";
export { ForwardRef as ReactComponent };